// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: white;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.search-bar {
  display: flex;
  align-items: center;
  background-color: #f0f2f5;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  margin-left: 0.5rem;
}

.search-input {
  border: none;
  background: none;
  outline: none;
  padding-left: 0.5rem;
  font-size: 0.9rem;
  width: 240px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.nav-icon {
  width: 24px;
  height: 24px;
  color: #606770;
  cursor: pointer;
}

.nav-icon:hover {
  color: #1877f2;
} `, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  background-color: white;\n  border-bottom: 1px solid #e0e0e0;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #f0f2f5;\n  border-radius: 20px;\n  padding: 0.5rem 1rem;\n  margin-left: 0.5rem;\n}\n\n.search-input {\n  border: none;\n  background: none;\n  outline: none;\n  padding-left: 0.5rem;\n  font-size: 0.9rem;\n  width: 240px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.nav-icon {\n  width: 24px;\n  height: 24px;\n  color: #606770;\n  cursor: pointer;\n}\n\n.nav-icon:hover {\n  color: #1877f2;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
